import AxiosInterceptor from "../utils/AxiosInterceptor";

const matchapi = {
//   add: (value) => AxiosInterceptor().post(`/contests/createContest`, value),
//   edit: (value) => AxiosInterceptor().post(`/update-cms`, value),
//   delete: (value) => AxiosInterceptor().post(`/delete-cms`, value),
  getAll: (values) => AxiosInterceptor().post(`/matches/getAllMatches`, values),
//   getById: (values) => AxiosInterceptor().post(`/get-cms`, values),
  // changeStatus: (values) =>
  //   AxiosInterceptor().post(`/admin/user/change-status`, values),
};

export default matchapi;
